import { Component } from '@angular/core';

interface Product {
  img: string;
  type: string | string[]; // 11..15 variedades, 21 denominaciones, 31..35 marcas (array si está en varias)
  title: string; // nombre propio (no se traduce)
  url: string;
  descKey: string; // clave i18n de la descripción
}

interface SubButton {
  type: number;
  labelKey: string;
}

const P = 'assets/img/productos/';
const ARRA_NS = [4, 5, 11, 13, '14-1', 15, 16, 18, 19, 27, 28, 29, 30, 31, 32, 33, 34];

@Component({
  selector: 'app-productos-gestionados',
  templateUrl: './productos-gestionados.component.html',
  styleUrls: ['./productos-gestionados.component.scss'],
})
export class ProductosGestionadosComponent {
  readonly products: Product[] = [
    // Variedades Protegidas · Mandarina/Clementina (11)
    { img: 'productos_Nadorcott.webp', type: '11', title: 'Nadorcott', url: 'https://www.clubvvp.com/', descKey: 'productos.desc.nadorcott' },
    { img: 'productos_Leanri.webp', type: '11', title: 'Leanri', url: 'https://www.clubvvp.com/', descKey: 'productos.desc.leanri' },
    { img: 'productos_Sando.webp', type: '11', title: 'Sando', url: 'http://www.sandoclementine.com/', descKey: 'productos.desc.sando' },
    { img: 'productos_ARCCIT9.webp', type: '11', title: 'ARCCIT9', url: 'https://www.citrogold.co.za/', descKey: 'productos.desc.arccit9' },
    { img: 'productos_Orri.webp', type: '11', title: 'Orri', url: 'https://www.orcspain.es/', descKey: 'productos.desc.orri' },
    { img: 'productos_Earlyna.webp', type: ['11', '31'], title: 'Earlyna®', url: 'http://earlyna.com/', descKey: 'productos.desc.earlyna' },
    // Naranja (12)
    { img: 'productos_m7.webp', type: '12', title: 'M7', url: 'https://www.clubvvp.com/', descKey: 'productos.desc.m7' },
    // Limón (13)
    { img: 'productos_SummerPrim.webp', type: '13', title: 'Summer Prim', url: 'https://www.clubvvp.com/', descKey: 'productos.desc.summerprim' },
    // Kiwi (14)
    { img: 'productos_Soreli.webp', type: '14', title: 'Soreli', url: 'https://soreli.uniud.it/', descKey: 'productos.desc.soreli' },
    // Uva (15)
    { img: 'productos_EarlySweet.webp', type: '15', title: 'Early Sweet', url: 'https://grapaes.com/', descKey: 'productos.desc.earlysweet' },
    ...ARRA_NS.map((n) => ({
      img: `productos_Arra${n}.webp`,
      type: '15',
      title: `ARRA ${n}`,
      url: 'https://grapaes.com/',
      descKey: 'productos.arraDesc',
    })),
    // Denominaciones de Origen · Aguacate (21)
    { img: 'productos_Aguacates.webp', type: '21', title: 'Aguacates de origen México', url: 'https://www.apeamac.com/', descKey: 'productos.desc.aguacateDO' },
    // Marcas · Mandarina (31)
    { img: 'productos_Clemcott.webp', type: '31', title: 'Clemcott', url: 'https://www.clubvvp.com/', descKey: 'productos.desc.clemcott' },
    { img: 'productos_ClemenGold.webp', type: '31', title: 'ClemenGold', url: 'https://www.clemengold.com/', descKey: 'productos.desc.clemengold' },
    { img: 'productos_SweetC.webp', type: '31', title: 'Sweet C', url: 'https://fruitalyst.com/', descKey: 'productos.desc.sweetc' },
    // Marcas · Naranja (32)
    { img: 'productos_ClemenOrange.webp', type: '32', title: 'ClemenOrange', url: 'https://fruitalyst.com/', descKey: 'productos.desc.clemenorange' },
    { img: 'productos_Bollo.webp', type: '32', title: 'Bollo', url: 'https://frutasbollo.es/', descKey: 'productos.desc.bollo' },
    // Marcas · Limón (33)
    { img: 'productos_LemonGold.webp', type: '33', title: 'LemonGold', url: 'https://www.clemengold.com/brand/lemongold/', descKey: 'productos.desc.lemongold' },
    // Marcas · Uva (34)
    { img: 'productos_SugarDrop.webp', type: '34', title: 'ARRA Sugar Drop', url: 'https://grapaes.com/', descKey: 'productos.desc.sugardrop' },
    { img: 'productos_ArraSweeties.webp', type: '34', title: 'ARRA Sweeties', url: 'https://grapaes.com/', descKey: 'productos.desc.arrasweeties' },
    // Marcas · Aguacate (35)
    { img: 'productos_Aguacates.webp', type: '35', title: 'Avocados from Mexico', url: 'https://avocadosfrommexico.com/', descKey: 'productos.desc.avocados' },
  ];

  readonly mains = [
    { n: 1, labelKey: 'productos.btn.variedades' },
    { n: 2, labelKey: 'productos.btn.denominaciones' },
    { n: 3, labelKey: 'productos.btn.marcas' },
  ];
  private readonly subs: Record<number, SubButton[]> = {
    1: [
      { type: 10, labelKey: 'productos.sub.all' },
      { type: 11, labelKey: 'productos.sub.mandarina' },
      { type: 12, labelKey: 'productos.sub.naranja' },
      { type: 13, labelKey: 'productos.sub.limon' },
      { type: 14, labelKey: 'productos.sub.kiwi' },
      { type: 15, labelKey: 'productos.sub.uva' },
    ],
    2: [{ type: 21, labelKey: 'productos.sub.aguacate' }],
    3: [
      { type: 30, labelKey: 'productos.sub.all' },
      { type: 31, labelKey: 'productos.sub.mandarina' },
      { type: 32, labelKey: 'productos.sub.naranja' },
      { type: 33, labelKey: 'productos.sub.limon' },
      { type: 34, labelKey: 'productos.sub.uva' },
      { type: 35, labelKey: 'productos.sub.aguacate' },
    ],
  };

  main = 1;
  buttonType = 10;

  get secondary(): SubButton[] {
    return this.subs[this.main];
  }

  setMain(n: number): void {
    this.main = n;
    this.buttonType = n === 1 ? 10 : n === 2 ? 21 : 30;
  }
  selectSub(type: number): void {
    this.buttonType = type;
  }

  isVisible(p: Product): boolean {
    const types = Array.isArray(p.type) ? p.type : [p.type];
    if (this.buttonType % 10 === 0) {
      return types.some((t) => t.charAt(0) === String(this.buttonType / 10));
    }
    return types.includes(String(this.buttonType));
  }
}
